"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilmLocalizedReferenceSchema = void 0;
exports.FilmLocalizedReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/localized/content/films.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "FilmLocalizedReference",
    "description": "Long form video content.",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:content:films"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmlsbXMuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL21vZHVsZXMvcmVmZXJlbmNlL2xvY2FsaXplZC9jb250ZW50L2ZpbG1zLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLDRCQUE0QixHQUFHO0lBQzFDLEtBQUssRUFBRSwrRUFBK0U7SUFDdEYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsd0JBQXdCO0lBQ2pDLGFBQWEsRUFBRSwwQkFBMEI7SUFDekMsTUFBTSxFQUFFLFFBQVE7SUFDaEIsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLElBQUk7S0FDTDtJQUNELFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRTtnQkFDTixtQkFBbUI7YUFDcEI7WUFDRCxNQUFNLEVBQUUsUUFBUTtTQUNqQjtRQUNELElBQUksRUFBRTtZQUNKLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFNBQVMsRUFBRSxpR0FBaUc7U0FDN0c7S0FDRjtDQUNGLENBQUEifQ==